import React from 'react';
import ModalControl, { ModalBody } from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/modalControl';
import {
    EmailShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    WhatsappIcon,
} from 'react-share';
import { MdContentCopy } from 'react-icons/md';
import { TbUpload } from 'react-icons/tb';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import useModalState from '@PROJECT_ROOT/assets/responsive-frontend/js/custom-hooks/useModalState';
import { SOCIAL_SHARE_MODAL_ID } from '@PROJECT_ROOT/assets/responsive-frontend/js/constants/modalIds';

export default function SocialShare({
    shareURL,
    socialShare,
    customButton,
    customClassNameForButton,
    trackingEvents,
}) {
    const [isModalOpen, setIsModalOpen] = useModalState(SOCIAL_SHARE_MODAL_ID);

    const handleShowModal = () => {
        setIsModalOpen(true);
        if (!IS_FRAME_SERVICE && trackingEvents?.onOpenModal) {
            dispatchTrackingEvent(trackingEvents.onOpenModal, trackingEvents.id ? { unitID: trackingEvents.id } : {});
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleSocialShareSelect = () => {
        if (trackingEvents?.onSocialShareSelect) {
            dispatchTrackingEvent(trackingEvents.onSocialShareSelect, { unitID: trackingEvents.id });
        }
    };

    const openSocialSharingLabel = 'Open social sharing options';

    return socialShare && (
        <>
            {customButton ? (
                <button
                    className={`social-share__open-modal-button-custom ${customClassNameForButton ?? ''}`}
                    type="button"
                    onClick={handleShowModal}
                    aria-label={openSocialSharingLabel}
                >
                    {customButton}
                </button>
            ) : (
                <button
                    type="button"
                    className={`social-share__open-modal-button ${customClassNameForButton ?? ''}`}
                    onClick={handleShowModal}
                    aria-label={openSocialSharingLabel}
                >
                    <TbUpload className="social-share__open-modal-button-icon" /> {socialShare.buttonText}
                </button>
            )}
            <ModalControl
                id={SOCIAL_SHARE_MODAL_ID}
                title={socialShare.title}
                isOpen={isModalOpen}
                disableBodyScroll={true}
                onClose={handleCloseModal}
                animate={true}
            >
                <ModalBody>
                    <div
                        className="social-share"
                        role="button"
                        tabIndex={0}
                        onClick={handleSocialShareSelect}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') handleSocialShareSelect();
                        }}
                        aria-label={openSocialSharingLabel}
                    >
                        <FacebookShareButton url={shareURL} quote={socialShare.title} className="social-share__button">
                            <FacebookIcon size={32} className="social-share__button-icon" /> <span>{socialShare.facebook}</span>
                        </FacebookShareButton>
                        <WhatsappShareButton url={shareURL} title={socialShare.title} className="social-share__button">
                            <WhatsappIcon size={32} className="social-share__button-icon" /> <span>{socialShare.whatsapp}</span>
                        </WhatsappShareButton>
                        <FacebookMessengerShareButton url={shareURL} quote={socialShare.title} className="social-share__button">
                            <FacebookMessengerIcon size={32} className="social-share__button-icon" /> <span>{socialShare.messenger}</span>
                        </FacebookMessengerShareButton>
                        <TwitterShareButton url={shareURL} title={socialShare.title} className="social-share__button">
                            <svg className="social-share__button-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <rect width="32" height="32" rx="4" fill="#070707" />
                                <path d="M15.122 7.125H16.776L13.1625 11.255L17.4135 16.875H14.085L11.478 13.4665L8.495 16.875H6.84L10.705 12.4575L6.627 7.125H10.04L12.3965 10.2405L15.122 7.125ZM14.5415 15.885H15.458L9.542 8.063H8.5585L14.5415 15.885Z" fill="white" />
                            </svg>
                            <span>{socialShare.twitter}</span>
                        </TwitterShareButton>
                        <EmailShareButton url={shareURL} subject={socialShare.title} className="social-share__button">
                            <EmailIcon size={32} className="social-share__button-icon" /> <span>{socialShare.email}</span>
                        </EmailShareButton>
                        <CopyToClipboard text={shareURL} className="social-share__button">
                            <button type="button" className="social-share__button">
                                <MdContentCopy className="social-share__button-icon social-share__button-icon--clipboard" /> <span>{socialShare.copyLink}</span>
                            </button>
                        </CopyToClipboard>
                    </div>
                </ModalBody>
            </ModalControl>
        </>
    );
}
